/**
 * @generated SignedSource<<2d04a96e145926778164fa91a4ebc5b1>>
 * @relayHash bf0e4355eedfe3ad5ece49575d709f4f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/387.0.0-2022-10-14T10:32:49.088Z/itemEventsShownMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ItemEventsShownInput = {
  clientMutationId?: string | null;
  userId: string;
};
export type itemEventsShownMutation$variables = {
  input: ItemEventsShownInput;
};
export type itemEventsShownMutation$data = {
  readonly itemEventsShown: {
    readonly favoriteNotifications: {
      readonly hasNewEvents: boolean | null;
    } | null;
  } | null;
};
export type itemEventsShownMutation = {
  response: itemEventsShownMutation$data;
  variables: itemEventsShownMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNewEvents",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "itemEventsShownMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ItemEventsShownPayload",
        "kind": "LinkedField",
        "name": "itemEventsShown",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "kind": "LinkedField",
            "name": "favoriteNotifications",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "itemEventsShownMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ItemEventsShownPayload",
        "kind": "LinkedField",
        "name": "itemEventsShown",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "kind": "LinkedField",
            "name": "favoriteNotifications",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/387.0.0-2022-10-14T10:32:49.088Z/itemEventsShownMutation",
    "metadata": {},
    "name": "itemEventsShownMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1282ef6d92da32b74264cdd1393e3f71";

export default node;
